import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ProductAuth16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_417)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.25 8C0.25 3.71979 3.71979 0.25 8 0.25C12.2802 0.25 15.75 3.71979 15.75 8C15.75 12.2802 12.2802 15.75 8 15.75C3.71979 15.75 0.25 12.2802 0.25 8ZM8 1.75C4.80204 1.75 2.16505 4.15183 1.79454 7.25H8.6894L6.46973 5.03033L7.53039 3.96967L11.5607 8L7.53039 12.0303L6.46973 10.9697L8.68939 8.75H1.79454C2.16505 11.8482 4.80204 14.25 8 14.25C11.4518 14.25 14.25 11.4518 14.25 8C14.25 4.54822 11.4518 1.75 8 1.75Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_417'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

ProductAuth16.displayName = 'ProductAuth16';
export default ProductAuth16;
